import { useState } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { EyeIcon } from "lucide-react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "@/hooks/useTranslation";
import ReferralsList from "../ReferralsList";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Button } from "../ui/button";
import CopyReferralCode from "../onboarding/CopyReferralCode";

export default function ReferralCard() {
  const [myReferralsOpen, setMyReferralsOpen] = useState(false);
  const t = useTranslation();

  return (
    <>
      <Card className="dark w-full max-w-lg">
        <CardHeader className="">
          <CardTitle className="flex flex-row text-xl items-center">
            {t.ACCOUNT_SETTINGS.LABELS.REFERRAL_CARD_TITLE}
          </CardTitle>
          <CardDescription>
            <NavLink to={"/refer"} className="text-sm text-zinc-400">
              {t.ACCOUNT_SETTINGS.LABELS.REFERRAL_CARD_DESCRIPTION}
            </NavLink>
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-row items-center mb-4">
            <CopyReferralCode />
          </div>
          <Button
            className="mt-1"
            variant="outline"
            onClick={() => setMyReferralsOpen(true)}
          >
            <EyeIcon className="h-4 w-4 mr-2" />
            {t.REFERRAL_LIST.LABELS.MY_REFERRALS}
          </Button>
        </CardContent>
      </Card>

      <Dialog open={myReferralsOpen} onOpenChange={setMyReferralsOpen}>
        <DialogContent className="dark text-white px-4 sm:px-6">
          <DialogHeader className="hidden">
            <DialogTitle />
            <DialogDescription />
          </DialogHeader>
          <ReferralsList border={false} />
        </DialogContent>
      </Dialog>
    </>
  );
}
